import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@material-ui/utils';
import { Box, Checkbox, TableRow, TableCell, TableHead, TableSortLabel, Tooltip } from '@material-ui/core';
import { SwapVert } from '@material-ui/icons';

// ----------------------------------------------------------------------

UserListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func
};

export default function UserListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick,
  showAllCheckBox,
  showIdLabel,
  showId,
  checkboxPresent=false
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
      {(!checkboxPresent)&&
      <TableCell padding="checkbox" align={showIdLabel ? 'center' : 'center'}
      sortDirection={showId && (orderBy === showId ? showId : false)}>
      {showAllCheckBox &&
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />
         }
         {showIdLabel &&
          <TableSortLabel
            // hideSortIcon
            active={orderBy === showId}
            direction={orderBy === showId ? order : 'asc'}
            onClick={createSortHandler(showId)}
            IconComponent={orderBy === showId ? undefined : SwapVert}
          >
            {showIdLabel}
            {orderBy === showId ? (
                <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
              ) : null}
          </TableSortLabel>
         }
         </TableCell>}
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignRight ? 'right' : headCell.alignLeft ? 'left' : 'center'}
            sortDirection={orderBy === headCell.id ? order : false}
            // sx={{ whiteSpace: showIdLabel ? null :'nowrap' }}
          >
            {(!headCell?.label || headCell?.label?.trim() == 'Options' || headCell?.label?.trim() == 'qb' || headCell?.label?.trim() == 'Qb' || headCell?.label?.trim() === '') ? (
              headCell.label
            ) : (
            <TableSortLabel
              // hideSortIcon
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              IconComponent={
                orderBy === headCell.id
                  ? undefined
                  : SwapVert
              }
            >
              {headCell?.tooltip ? (
                <Tooltip title={headCell?.tooltip} >
                  <span>{headCell.label}</span>
                </Tooltip>
              ) : (
                headCell.label
              )}
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
              ) : null}
            </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
